import {
	Component,
	Input,
	Output,
	EventEmitter,
	ViewChild,
	ElementRef,
	OnDestroy,
	OnInit
} from "@angular/core";

import { IdService } from "../../shared/services/id.service";
@Component({
	selector: "rbc-button-toggle-inner",
	template: `
		<div
			[ngClass]= "{checked: isChecked()}"
			class="rbc-button-toggle-inner"
			(mouseout)="removeFocus()">
			<input
				#control
				[name]="name"
				[id]="id + value"
				[disabled]="disabled"
				[value]="value"
				[checked]="isChecked()"
				(change)="updateSelected($event)"
				type="radio"
				class="rbc-button-toggle-control"
			/>

			<label
				[id]="id + value + 'Label'"
				[for]="id + value"
				class="rbc-button rbc-button-toggle-label"
				[ngClass]="{ disabled: disabled }"
				[attr.data-label]="label"
			>
				{{ label }}
			</label>
		</div>
	`,
	styles: []
})
export class ButtonToggleInnerComponent implements OnDestroy {
	@Input() id: string;
	@Input() selected: string;
	@Input() disabled: boolean;
	@Input() name: string;
	@Input() value: string;
	@Input() label: string;

	@Output() change = new EventEmitter();

	@ViewChild("control", { static: false }) control: ElementRef;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id + this.value);
		this.idService.remove(this.id + this.value + "Label");
	}

	updateSelected(event) {
		this.change.emit(event.target.value);
	}

	isChecked() {
		return this.selected === this.value;
	}

	removeFocus() {
		this.control.nativeElement.blur();
	}
}
